
import { Component, Prop, Vue } from 'vue-property-decorator';
import { BackupRepoDto, BackupRepoRepositoryInterface } from "@/services/Backup/interfaces";
import { AxiosError } from "axios";

@Component({
  inject: ['backupRepoRepository'],
})
export default class BackupRepoPicker extends Vue {
  private backupRepoRepository!: BackupRepoRepositoryInterface;

  public backupRepoSearchLoading = false;

  public backupRepos: BackupRepoDto[] = [];

  @Prop({ default: 0, required: true, type: Number }) public value!: number;

  private _backupRepoSearch = '';

  public get backupRepoSearch(): string {
    return this._backupRepoSearch;
  }

  public set backupRepoSearch(val: string) {
    this._backupRepoSearch = val;

    this.fetchBackupRepos(val);
  }

  get backupRepoId(): number {
    return this.value;
  }

  set backupRepoId(value: number) {
    if (value !== this.value) {
      this.$emit('input', value);
    }
  }

  public async fetchBackupRepos(query: string): Promise<void> {
    try {
      this.backupRepoSearchLoading = true;
      const result = await this.backupRepoRepository.getAllBackupRepos({
        page: 1,
        pageSize: 10,
        search: query,
      });

      this.backupRepos = result?.data ?? [];

    } catch (err) {
      this.onError(err);
    } finally {
      this.backupRepoSearchLoading = false;
    }
  }

  private onError(err: unknown): void {
    const asAxiosError = err as AxiosError;
    if (asAxiosError.isAxiosError) {
      this.$errorDialog.show(asAxiosError.response?.data?.message ?? 'An axios error occurred');
    } else if (err instanceof Error) {
      this.$errorDialog.show(err.message);
    } else {
      this.$errorDialog.show('An unknown error occurred');
    }
  }
}

